module.exports = __webpack_public_path__ + "static/media/studies_icon.e08a4b8a.svg";